import LyfeTooltip from "../../../components/LyfeTooltip";
import { Treatment, TreatmentDetails } from "./TreatmentSummaryDetails";
import { Typography } from "@material-ui/core";
import { Fragment, Key } from "react";
import { EMPTY_VALUE_PLACEHOLDER } from "../../../models/common/data";
import useStyles from "../use-styles";

interface ITreatmentPriceColumns {
	hasMultipleBasePrices?: boolean;
	treatment: Treatment;
	currencyName: string;
	usedTreatments:
		| Array<{
				brandName: string | undefined;
				code: string | undefined;
		  }>
		| undefined;
}

const TreatmentPriceColumns = ({ hasMultipleBasePrices, treatment, currencyName, usedTreatments }: ITreatmentPriceColumns) => {
	const { smallItem, cellRightAlignment } = useStyles();

	if (hasMultipleBasePrices) {
		return (
			<>
				<td className={`${smallItem}, ${cellRightAlignment}`}>
					<LyfeTooltip title={currencyName}>
						<div>
							{treatment.details?.length > 0&&
								treatment.details.map((details: TreatmentDetails, di?: Key) => (
									<Fragment key={di}>
										<Typography
											style={{
												color: usedTreatments?.find((current) => details.code === current.code)
													? "#212121"
													: "#969392",
											}}
											noWrap
										>
											{details.exFactoryPrice || EMPTY_VALUE_PLACEHOLDER}
										</Typography>
									</Fragment>
								))}
						</div>
					</LyfeTooltip>
				</td>
				<td className={`${smallItem}, ${cellRightAlignment}`}>
					<LyfeTooltip title={currencyName}>
						<div>
							{treatment.details?.length > 0 &&
								treatment.details.map((details: TreatmentDetails, di?: Key) => (
									<Fragment key={di}>
										<Typography
											style={{
												color: usedTreatments?.find((current) => details.code === current.code)
													? "#212121"
													: "#969392",
											}}
											noWrap
										>
											{details.publicPrice || EMPTY_VALUE_PLACEHOLDER}
										</Typography>
									</Fragment>
								))}
						</div>
					</LyfeTooltip>
				</td>
			</>
		);
	}

	return (
		<td className={`${smallItem}, ${cellRightAlignment}`}>
			<LyfeTooltip title={currencyName}>
				<div>
					{treatment.details?.length > 0 &&
						treatment.details.map((details: TreatmentDetails, di?: Key) => (
							<Fragment key={di}>
								<Typography
									style={{
										color: usedTreatments?.find((current) => details.code === current.code) ? "#212121" : "#969392",
									}}
									noWrap
								>
									{details.basePrice || EMPTY_VALUE_PLACEHOLDER}
								</Typography>
							</Fragment>
						))}
				</div>
			</LyfeTooltip>
		</td>
	);
};

export default TreatmentPriceColumns;
